import { TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import { TableRow } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const AssessmentTemplateHeader: React.FC = () => {
  const { formatMessage } = useIntl()
  return (
    <TableRow>
      <TableHeaderCell
        minWidth={TableCellWidth.LARGE}
        label={formatMessage({ id: 'schemas.assessmentTemplate.name' })}
      />
      <TableHeaderCell label={formatMessage({ id: 'schemas.assessmentTemplate.description' })} />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.assessmentTemplate.published' })}
        minWidth={TableCellWidth.SMALL}
      />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.assessmentTemplate.createdAt' })}
        minWidth={TableCellWidth.SMALL}
      />
      <TableHeaderCell minWidth={TableCellWidth.EMPTY} label="" />
    </TableRow>
  )
}

export default AssessmentTemplateHeader
